<!-- About us Start -->
<section class="section why-choose-us" id="about" style="background: #6320CE; background-size: cover;">
  <div class="" style="width: 100%; display:flex;justify-content:center;">
    <!-- <div class="absolute">
      <img src="/assets/images/transition-pattern.png" class="img-responsive relative" />
    </div> -->
  </div>
  <div class="svg-container">
    <svg viewBox="0 0 1440 127" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="-95" rx="808.5" ry="222" fill="white" />
    </svg>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12" style="padding-top:10rem !important;padding-bottom:10rem !important">
        <div class="title text-center mb-5">
          <h1 class="font-weight-normal text-white mb-5">WHY CHOOSE US ?</h1>

          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="card card-details text-left p-5"
                  style="background-image: url(/assets/images/time-machine\ 2.svg)">
                  <div class="row">
                    <div class="icon-holder center col-md-2 col-sm-12">
                      <img src="/assets/images/time-machine 1.svg" />
                    </div>
                    <div class="col-md-10 col-sm-12">
                      <br />
                      <h3>TIME ZONE ALIGNMENT</h3>
                      <p>We have resources in different time zones and are particular about placing our best resources
                        with
                        your firm to
                        complement your working day. We promise a fully collaborative workday from our personnel on any
                        business day, with no
                        outsourced holidays. <br /></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="card card-details text-left p-5"
                  style="background-image: url(/assets/images/mesh-side.svg)">
                  <div class="row">
                    <div class="icon-holder center col-md-2 col-sm-12">
                      <img src="/assets/images/mesh.svg" />
                    </div>
                    <div class="col-md-10 col-sm-12">
                      <h3>COMMUNICATION & CONTRIBUTION</h3>
                      <p>Our technical resources are communication savvy and proficient in multiple languages. We invest
                        heavily in teaching the
                        soft skills needed to work in the western work culture – align with company culture and discern
                        unspoken rules in order
                        to be of intrinsic value to your team; the project and attainment of your ROIs.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="card card-details text-left p-5"
                  style="background-image: url(/assets/images/tech-laptop-sided.svg)">
                  <div class="row">
                    <div class="icon-holder center col-md-2 col-sm-12">
                      <img src="/assets/images/tech-laptop.svg" />
                    </div>
                    <div class="col-md-10 col-sm-12">
                      <br />
                      <h3>TECHNICAL PROFICIENCY</h3>
                      <p>We provide a pre-vetted agile certified talent pool that stays current and fresh by constantly
                        seeking new
                        certifications to ensure that we are always aligned with our client's needs. <br /></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="card card-details text-left p-5"
                  style="background-image: url(/assets/images/wallet-side.svg)">
                  <div class="row">
                    <div class="icon-holder center col-md-2 col-sm-12">
                      <img src="/assets/images/wallet.svg" />
                    </div>
                    <div class="col-md-10 col-sm-12">
                      <br /><br />
                      <h3>COMPETITIVE FTE WAGES</h3>
                      <p>
                        We offer better monetary value in comparison to the best technical consultancy firms.
                        <br /><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="svg-container">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="#FAF5FF" />
    </svg>
  </div>

</section>
<!-- About us End -->
